<template>
  <div class="card-wrapper" :class="{ 'card-wrapper--embedded': embedded }">
    <!-- <LanguageS class="language-btn-box"></LanguageS> -->
    <div v-if="!embedded" class="card-gift-decor" aria-hidden="true">
      <span class="gift-float soft gift-one">🎁</span>
      <span class="gift-float soft gift-two">🎁</span>
      <span class="gift-float soft gift-three">🎀</span>
      <span class="gift-float soft gift-four">✨</span>
      <span class="gift-float soft gift-five">💳</span>
      <span class="gift-float soft gift-six">🎁</span>
      <span class="gift-float soft gift-seven">✨</span>
      <span class="gift-float soft gift-eight">🎁</span>
    </div>
    <slot></slot>
    <div class="card-btn-box" v-if="showBtn">
      <van-button v-if="prevStepName" @click="prevStep" class="btn btn-prev">{{
        $t("btnPrev")
      }}</van-button>
      <van-button
        @click="changeStep"
        :disabled="disabled"
        class="btn btn-next"
        >{{ btnMsg }}</van-button
      >
    </div>
    <slot name="after-actions"></slot>
  </div>
</template>
<script>
import LanguageS from "./language.vue";
export default {
  components: {
    LanguageS,
  },
  props: {
    btnMsg: String,
    flowProxy: {
      type: Boolean,
      default: false,
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    prevStepName: {
      type: String,
      default: "",
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    selectedGift: {
      get() {
        return this.flowProxy ? this.$parent.selectedGift : undefined;
      },
      set(value) {
        if (this.flowProxy) this.$parent.selectedGift = value;
      },
    },
    loading: {
      get() {
        return this.flowProxy ? this.$parent.loading : false;
      },
      set(value) {
        if (this.flowProxy) this.$parent.loading = value;
      },
    },
  },
  methods: {
    changeStep(step, data) {
      if (this.flowProxy) {
        this.$parent.changeStep(step, data);
        return;
      }
      this.$emit("changeStep");
    },
    prevStep() {
      if (this.flowProxy) {
        this.$parent.prevStep(this.prevStepName);
        return;
      }
      this.$parent.prevStep(this.prevStepName);
    },
  },
};
</script>
<style lang="scss">
.card-wrapper {
  display: flex;
  //   justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  width: calc(100% - 48px);
  max-width: 600px;
  height: fit-content;
  max-height: 80%;
  overflow-y: auto;
  background: #fff url("../assets/bg.png") center / 100% 100% no-repeat;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  .card-btn-box {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-top: 20px;
    .btn {
      width: 184px;
      font-size: 16px;
      font-weight: 500;
      background: linear-gradient(to bottom, #ffd814, #ffa031);
      border: 1px solid #fff;
    }
    .btn-prev {
      width: 120px;
      background: transparent;
      border: 1px solid #e5e7eb;
      color: #374151;
    }
    .btn-next {
      /* uses the .btn style */
    }
  }
}
</style>
